// extracted by mini-css-extract-plugin
module.exports = {"notice":"IajsD","body":"_3UPZu","close":"_38orq","content":"_12Ult","title":"_3DZ8K","subTitle":"_2qYzs","subTitle2":"WaD3Q","intro":"_4B-Qw","link":"_1X6Dg"};